import { PayloadAction } from '@reduxjs/toolkit';
import { createSliceWithStateReset } from 'store/createSliceWithStateReset';
import { RootState } from 'store/store';

interface State {
  surveyTask?: SurveyTask;
}

const initialState: State = {
  surveyTask: undefined,
};

const surveySlice = createSliceWithStateReset({
  name: 'survey',
  initialState,
  reducers: {
    setState: (_, action: PayloadAction<SurveyTask | undefined>) => ({
      surveyTask: action.payload,
    }),
    updateStepAnswer: (state, action: PayloadAction<{ answer: string; stepIndex: number }>) => {
      const { surveyTask } = state;

      if (surveyTask) {
        const { answer, stepIndex } = action.payload;

        return {
          surveyTask: {
            ...surveyTask,
            steps: surveyTask.steps.map((step, index) =>
              index === stepIndex ? { ...step, answer } : step,
            ),
          },
        };
      }

      return state;
    },
  },
});

export const { setState, updateStepAnswer } = surveySlice.actions;
export const { reducer: surveyReducer } = surveySlice;
export const selectSurveyData = (state: RootState) => state.survey;
